export default __webpack_public_path__ + "static/galeria-launch_1_1_de-50b77c16d63a26561ff53eedf2730000.png";